import { MarketResearchJobInsights, MarketResearchType } from "@relode/core";
import * as React from "react";

import { useJobContext } from "../../../_infra";

export const JobMarketResearch = () => {
    const {
        state: {
            data: { job, marketResearch, marketResearchAvailable },
        },
        actions,
    } = useJobContext();

    const jobId = job?.details?.jobId;

    const handleLoadMarketResearchSummary = async () => {
        // no sorting or anything that could change this once loaded so ignore collapse/expand calls
        if (!!marketResearch.summary.data) return;

        const summary = actions.loadMarketResearchSummary(jobId);

        const share = actions.loadMarketResearchShare(jobId);

        await Promise.all([summary, share]);
    };

    const handleLoadMarketResearchCompensation = async () => {
        // no sorting or anything that could change this once loaded so ignore collapse/expand calls
        if (!!marketResearch.compensation.data) return;
        await actions.loadMarketResearchCompensation(jobId);
    };
    const handleLoadMarketResearchSupplyDemand = async () => {
        // no sorting or anything that could change this once loaded so ignore collapse/expand calls
        //if (!!marketResearch.supplyDemand.data) return;
        await actions.loadMarketResearchSupplyDemand(jobId);
    };

    const handleLoadMarketResearchDiversity = async () => {
        // no sorting or anything that could change this once loaded so ignore collapse/expand calls
        if (!!marketResearch.diversity.data) return;
        await actions.loadMarketResearchDiversity(jobId);
    };

    return (
        <MarketResearchJobInsights
            jobId={jobId}
            state={marketResearch}
            marketResearchType={MarketResearchType.PrivateJob}
            onLoadSummary={handleLoadMarketResearchSummary}
            onLoadCompensation={handleLoadMarketResearchCompensation}
            onLoadDiversity={handleLoadMarketResearchDiversity}
            onLoadSupplyDemand={handleLoadMarketResearchSupplyDemand}
        />
    );
};
